import {
  DELETE,
  GET,
  PUT,
  PATCH,
  POST
} from 'helpers/services/constants/API_CONSTANTS';
import {
  API_ACTIVE_ORDERS_V2,
  API_CALCULATE_ORDER_ADJUST_V2,
  API_CANCEL_ORDER_DELIVERY,
  API_CREATE_ORDER_ADJUST_V2,
  API_DELETE_DRIVER_RATING,
  API_DISPATCH_INFO,
  API_GET_DELIVERY_ORDER_TRACKING,
  API_GET_DRIVER_RATING,
  API_GET_ORDER_REFUND_DATA_V2,
  API_ORDER_REFUND_V2,
  API_ORDER_V2,
  API_ORDERS_V2,
  API_RATE_DRIVER,
  API_TEST_ORDER,
  API_UPDATE_DRIVER_RATING,
  API_CONVERT_ORDER_TO_LOCATION_DELIVERY,
  API_UPDATE_ORDER_STATUS_V2,
  LOCATION_CLOUD_PRINT,
  LOCATION_DATA,
  LOCATION_NOTIFICATIONS,
  PATCH_LOCATION
} from 'helpers/services/constants/API_ENDPOINTS';
import {request} from 'helpers/services/utils/request';

export const postHistoryOrdersApi = async (data, locationId) => {
  return request(POST, API_ORDERS_V2(locationId), {data});
};

export const postOrderApi = async (id, data) => {
  return request(POST, API_UPDATE_ORDER_STATUS_V2(id), {data});
};

export const getOrderApi = async (id) => {
  return request(GET, API_ORDER_V2(id));
};
export const getDispatchInfoApi = async (id) => {
  return request(GET, API_DISPATCH_INFO(id));
};

export const getActiveOrdersApi = async (locationId) => {
  return request(GET, API_ACTIVE_ORDERS_V2(locationId));
};

export const getLocationDataApi = async (locationId) => {
  return request(GET, LOCATION_DATA(locationId));
};

export const getLocationNotificationsApi = async (locationId, userId) => {
  return request(GET, LOCATION_NOTIFICATIONS(locationId, userId));
};

export const getCloudPrintConfigurationsApi = async (locationId) => {
  return request(GET, LOCATION_CLOUD_PRINT(locationId));
};

export const updateCloudPrintConfigurationsApi = async (locationId, data) => {
  return request(PUT, LOCATION_CLOUD_PRINT(locationId), {data});
};

export const patchLocationApi = async ({locationId, id, data}) => {
  return request(PATCH, PATCH_LOCATION(locationId, id), {data});
};

export const postTestOrder = async () => {
  return request(POST, API_TEST_ORDER());
};
export const updateOrderRefund = async (invoiceId, data) => {
  return request(POST, API_ORDER_REFUND_V2(invoiceId), {data});
};

export const calculateOrderAdjust = async (invoiceId, data) => {
  return request(POST, API_CALCULATE_ORDER_ADJUST_V2(invoiceId), {data});
};
export const createOrderAdjust = async (invoiceId, data) => {
  return request(POST, API_CREATE_ORDER_ADJUST_V2(invoiceId), {data});
};

export const getOrderRefundData = async (invoiceId) => {
  return request(GET, API_GET_ORDER_REFUND_DATA_V2(invoiceId));
};

export const getDeliveryTrackingApi = async (deliveryId, locationId) => {
  return request(GET, API_GET_DELIVERY_ORDER_TRACKING(deliveryId, locationId));
};
export const cancelOrderDelivery = async (deliveryId, data) => {
  return request(POST, API_CANCEL_ORDER_DELIVERY(deliveryId), {data});
};

export const rateDriverApi = async (data) => {
  return request(POST, API_RATE_DRIVER(), {data});
};

export const getDriverRatingApi = async (deliveryId) => {
  return request(GET, API_GET_DRIVER_RATING(deliveryId));
};

export const updateDriverRatingApi = async (deliveryId, data) => {
  return request(PUT, API_UPDATE_DRIVER_RATING(deliveryId), {data});
};

export const deleteDriverRatingApi = async (deliveryId) => {
  return request(DELETE, API_DELETE_DRIVER_RATING(deliveryId));
};

export const convertOrderToLocationDeliveryApi = (id) =>
  request(POST, API_CONVERT_ORDER_TO_LOCATION_DELIVERY(id));
